<template>
  <div class="home">
    <el-container>
      <el-header>
        <el-row class="header">
          <h1>TDI Admin</h1>
          <el-button
            type="info"
            icon="el-icon-user"
            @click="signOut"
            class="logout-btn"
            alt="logout"
            size="small"
          >Logout</el-button>
        </el-row>
      </el-header>
      <el-main>
        <el-row :gutter="0">
          <p>To make adjustments to a vehicle entry, please input the vin for the desired vehicle below.</p>
        </el-row>
        <el-row :gutter="10">
          <el-col el-col :span="6">
            <el-input placeholder="Please input VIN" v-model="input" clearable></el-input>
          </el-col>
          <el-col el-col :span="6">
            <el-button type="primary" plain @click="submitVin">Submit</el-button>
          </el-col>
          <el-col :span="12"></el-col>
        </el-row>
        <el-row v-if="loading" :gutter="0">
          <div class="loader"></div>
        </el-row>
        <el-row class="error-block">
          <el-alert
            v-if="vinError"
            title="Vin Error"
            type="error"
            description="The selected vin is invalid"
            show-icon
          ></el-alert>
          <el-alert
            v-if="ccError"
            title="Country Code Error"
            type="error"
            description="The selected country code could not be updated."
            show-icon
          ></el-alert>
          <el-alert
            v-if="formError"
            title="Vin Error"
            type="error"
            description="The selected form could not be reset"
            show-icon
          ></el-alert>
          <el-alert
            v-if="serverError"
            title="Server Error"
            type="error"
            description="The server is offline"
            show-icon
          ></el-alert>
        </el-row>
        <el-row v-if="vinData" class="vin-table-row">
          <h3 class="table-title">Vehicle Data</h3>
          <el-table
            class="vin-table"
            stripe
            empty-text="No VIN Selected"
            :data="vinData"
            v-loading="loading"
          >
            <el-table-column prop="vin" label="VIN" width="200"></el-table-column>
            <el-table-column prop="dealer_code" label="Dealer" width="70"></el-table-column>
            <el-table-column prop="make" label="Make" align="center"></el-table-column>
            <el-table-column prop="model" label="Model"></el-table-column>
            <el-table-column prop="model_year" label="Year"></el-table-column>
            <el-table-column prop="engine" label="Engine"></el-table-column>
            <el-table-column prop="generation" label="Generation"></el-table-column>
            <el-table-column prop="country_code" label="Country Code"></el-table-column>
          </el-table>
          <el-row :gutter="0">
            <p>Select country code below to update.</p>
          </el-row>
          <el-row :gutter="10">
            <el-col el-col :span="3">
              <el-select size="mini" v-model="newCC" placeholder="-">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-col>
            <el-col :span="0"></el-col>
            <el-col el-col :span="3">
              <el-button
                v-if="newCC != '-' && newCC != vinData[0]['country_code']"
                plain
                @click="submitCC"
                size="mini"
                type="danger"
              >Update Country Code</el-button>
            </el-col>
            <el-col :span="10"></el-col>
          </el-row>
        </el-row>
        <el-row v-if="formData" class="form-table-row">
          <h3 class="table-title">Froms Completed</h3>
          <el-table
            class="from-table"
            stripe
            empty-text="No forms have been completed for this vehicle"
            :data="formData"
          >
            <el-table-column prop="converted_title" label="Title"></el-table-column>
            <el-table-column prop="form_completion_phase" label="Phase" align="center"></el-table-column>
            <el-table-column prop="f_completed_at" label="Completion Date" align="center"></el-table-column>
            <el-table-column label="Operations" align="right">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  type="danger"
                  @click="handlePopupConfirmation(scope.row.form_record_id, scope.row.form_completion_id, scope.row.converted_title)"
                  v-if="scope.row.converted_title"
                >Reset Form</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-row>
      </el-main>
    </el-container>
    <el-dialog
      title="Form Reset"
      :visible.sync="formResetVisible"
      width="40%"
      :before-close="handleClose"
    >
      <span>Are you sure you would like to reset {{formResetTitle}}?</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">Cancel</el-button>
        <el-button type="danger" @click="handleRemove(formResetFormId, formResetCompletionId); handleClose() ">Reset Form</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  data() {
    return {
      input: "",
      converted_title: false,
      vinData: false,
      formData: false,
      newCC: "-",
      options: [
        {
          value: "USA",
          label: "USA"
        },
        {
          value: "CAN",
          label: "CAN"
        }
      ],
      loading: false,
      vinError: false,
      ccError: false,
      formError: false,
      serverError: false,
      formResetVisible: false,
      formResetTitle: "", 
      formResetCompletionId: 0,
      formResetFormId: 0
    };
  },
  name: "home",
  methods: {
    handleClose() {
      // console.log('handle close');
      this.formResetVisible = false; 
      this.formResetTitle = ""; 
      this.formResetCompletionId = 0; 
      this.formResetFormId = 0; 
    },
    handlePopupConfirmation(id, form_completion_id, form_title) {
      this.formResetVisible = true; 
      this.formResetTitle = form_title; 
      this.formResetCompletionId = form_completion_id; 
      this.formResetFormId = id; 
      // this.handleRemove(id, form_completion_id);
    },
    signOut() {
      console.log("sing out");
      this.loading = true;
      localStorage.removeItem("token");
      this.pageLoad();
    },
    async submitCC() {
      console.log("cc", this.vinData[0].vin);
      try {
        this.loading = true;
        this.ccError = false;
        this.vinError = false;
        this.serverError = false;
        this.formError = false;
        let result = await this.axios({
          method: "post",
          url:
            process.env.VUE_APP_API_URL +
            "/vin?vin=" +
            this.vinData[0].vin +
            "&cc=" +
            this.newCC +
            "&vin_id=" +
            this.vinData[0].id,
          headers: { Authorization: localStorage.token },
          params: { user_email: localStorage.user_email }
        })
          .then(results => {
            this.loading = false;
            this.ccError = false;
            console.log(results);
            if (!results.data.error) {
              this.submitVin();
            }
            if (results.status === 500) {
              console.log("server error");
            }
          })
          .catch(error => {
            this.loading = false;
            this.ccError = true;
            console.log(error);
            if (error.response.status < 500) {
              this.$router.push("/login");
            } else {
              this.serverError = true;
              console.log("server error: ", error.response);
            }
          });
      } catch (err) {
        console.log("error");
      }
    },
    async submitVin() {
      console.log("submitting vin");
      this.loading = true;
      this.vinData = false;
      this.formData = false;
      this.ccError = false;
      this.vinError = false;
      this.serverError = false;
      this.formError = false;
      try {
        let body = await this.axios({
          method: "get",
          url: process.env.VUE_APP_API_URL + "/vin?vin=" + this.input,
          timeout: 10000,
          headers: { Authorization: localStorage.token },
          params: { user_email: localStorage.user_email }
        })
          .then(results => {
            this.loading = false;
            this.vinError = false;
            if (results.data.data[0]) this.vinData = results.data.data[0];
            let curForm = results.data.data[1];
            for (let i = 0; i < curForm.length; i += 1) {
              curForm[i].f_completed_at =
                this.moment(curForm[i].f_completed_at).format(
                  "MM/DD/YYYY @ hh:mm A"
                ) + " UTC";
            }
            if (results.data.data[1]) this.formData = results.data.data[1];
          })
          .catch(error => {
            this.loading = false;
            if (error.response) {
              if (error.response.status < 500) {
                this.$router.push("/login");
              } else {
                this.vinError = true;
                console.log("server error: ", error.response);
              }
            } else {
              this.serverError = true;
            }
          });
      } catch (err) {
        console.log(err);
      }
    },
    async handleRemove(id, form_completion_id) {
      console.log(id, form_completion_id);
      this.loading = true;
      this.ccError = false;
      this.vinError = false;
      this.serverError = false;
      this.formError = false;
      // console.log(process.env.VUE_APP_API_URL + "/form?id=" + id + "&vin=" + this.vinData[0].vin + "&vin_id=" + this.vinData[0].id);
      try {
        let result = await this.axios({
          method: "post",
          url:
            process.env.VUE_APP_API_URL +
            "/form?id=" +
            id +
            "&vin=" +
            this.vinData[0].vin +
            "&vin_id=" +
            this.vinData[0].id +
            "&form_completion_id=" +
            form_completion_id,
          timeout: 10000,
          headers: { Authorization: localStorage.token },
          params: {
            user_email: localStorage.user_email
          }
        })
          .then(results => {
            this.loading = false;
            this.ccError = false;
            if (results.data.data.okay) {
              this.submitVin();
            }
            if (results.status === 500) {
              console.log("server error");
            }
          })
          .catch(error => {
            this.loading = false;
            console.log(error);
            if (error.response) {
              if (error.response.status < 500) {
                this.$router.push("/login");
              } else {
                this.ccError = true;
                console.log("server error: ", error.response);
              }
            } else {
              this.serverError = true;
            }
          });
      } catch (err) {
        console.log(err);
      }
    },
    async pageLoad() {
      if (!localStorage.token) {
        this.$router.push("/login");
      } else {
        try {
          let ret = await this.axios({
            method: "post",
            url: process.env.VUE_APP_API_URL + "/users/",
            timeout: 10000,
            headers: { Authorization: localStorage.token },
            params: { user_email: localStorage.user_email }
          })
            .then(result => {
              this.loading = false;
              if (!result.data.data.okay) {
                this.$router.push("/login");
              } else {
                console.log("valid tokin");
              }
            })
            .catch(error => {
              this.loading = false;
              if (error.response) {
                if (error.response.status < 500) {
                  this.$router.push("/login");
                } else {
                  console.log("server error: ", error.response);
                }
              } else {
                console.log(error);
                this.serverError = true;
              }
            });
        } catch (err) {
          console.log(err);
        }
      }
    }
  },
  mounted() {
    document.title = "TDI Admin | Console";
    this.pageLoad();
  },
  beforeMount() {
    this.pageLoad();
  }
};
</script>
<style scoped>
.vin-table-row,
.dropdown {
  margin: 30px 0px;
}
.dropdown-cc {
  margin-left: 10px;
  margin-right: 10px;
}
.vin-table {
  width: 100%;
  align: center;
}
.table-title {
  margin: unset !important;
  text-align: center;
}
* {
  -webkit-font-smoothing: antialiased;
}

.header {
  display: inline-flex;
  float: left;
  position: relative;
  width: 100%;
}
.logout-btn {
  position: absolute;
  right: 0px;
  margin: 10px;
}
.error-block {
  margin: 20px 0px;
}
</style>
